import { bulkExportUrl } from "../../bulkBaseUrl";

export const bulkDownloadFileUrl = `${bulkExportUrl}/file`;
export const bulkDownloadFileKey = "bulkDownloadFileUrl";
